<template>
    <div>
      <loading v-if="loading"></loading>
      <div class="header">
          <div class="layout-wrapper">
              <header id="page-topbar">
                  <BaseButton variant="secondary" @click="$router.push({ path:`/employee-and-role`, hash: '#second'})">Quay lại</BaseButton>
              <div class="title">
                  <p>Thêm mới vai trò</p>
              </div>
                  <el-button type="primary" @click="submitForm('ruleForm')">Hoàn tất</el-button>
              </header>
          </div>
      </div>
        
      <div class="boxContent boxContentExt" style="margin-top:110px">      
        <div class="__card first-box">
          <LayoutCardTitle>Thêm mới vai trò</LayoutCardTitle>
          <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="160px" style="width: 100%;" :inline="true">
            <el-row style="margin-bottom: 24px">
              <el-col :span="20">
                <el-form-item label="Tên vai trò" prop="roleName">
                  <el-input v-model="ruleForm.roleName" placeholder="vd: Quản lí cửa hàng" ></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row style="margin-bottom:24px">
              <el-col :span="20">
                <el-form-item label="Ghi chú:" class="mb-0" prop="description">
                  <el-input v-model="ruleForm.description" type="textarea" placeholder="Nhập ghi chú cho vai trò" ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </div>

      <div class="boxContent boxContentExt">      
        <div class="__card first-box">
          <LayoutCardTitle>Phân quyền vai trò</LayoutCardTitle>
          <div class="groupPers" v-for="(item, index) in dataPermissions" :key="index">
            <div class="group-head">
              <label class="group-item">
                <input type="checkbox" 
                @change="checkBoxRole(item , $event)"
                v-model="item.checkbox"/>
                <b class="ml-2 fz-14">{{item.groupName}}</b><i class="fa fa-angle-double-down"></i>
              </label>
            </div>
            <div class="line-item" v-if="item.permissions && item.permissions.length > 0">
              <div class="row">
                <div class="col-md-6" v-for="(sub, key) in item.permissions" :key="key">
                  <label class="item-one">
                    <input class="item-check" type="checkbox"
                      @change="checkBoxPermisstion(sub , item , index)"
                      :checked="isChecked(sub.permissionCode)"/>
                      <span class="item-name">{{sub.permissionName}}</span>
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>
<script>
import Swal from "sweetalert2";
import titlePage from '@/components/title-page'
import {RoleService} from '@/services/nextshop/role.service'
  export default {
    components: {
      titlePage
    },
    data() {
      return {
        ruleForm: {
          roleName: '',
          description: '',
        },
        rules: {
          roleName: [
            { required: true, message: 'Tên vai trò không được bỏ trống', trigger: 'blur' },
          ],
        },
        inforAccount: JSON.parse(localStorage.getItem("auth.currentUser")),
        dataPermission: JSON.parse(localStorage.getItem("dataPermission")),
        loading: false,
        perPage: 2000,
        currentPage: 1,
        dataRole: [],
        clickItemDelete: false,
        listCheckBox: [],
        dataPermissions: [],
        txtErrors: '',
        items: [
          {
            text: "Phân quyền vai trò",
            href: JSON.parse(localStorage.getItem("dataPermission")) && JSON.parse(localStorage.getItem("dataPermission")).includes('NSH_IAM_ROLE_VIEW') ?
            "/role" : "#",
          },
          {
            text: "Thêm mới vai trò",
            active: true,
          },
        ]
      }
    },

    async created() {
      this.getPermissions()
      this.isChecked()
    },

    methods: {
      // list permission
      async getPermissions() {
        try {
          this.loading = true
          const dataResPers = await RoleService.getPermissionsApp({
            lang: "vn",
            limit: this.perPage,
            page: this.currentPage,
          })
          if (dataResPers.success) {
            this.dataPermissions = (dataResPers.data.groupPermissions) ? dataResPers.data.groupPermissions : []
            this.loading = false
          }
        } catch (error) {
          console.log(error);
        }
      },
      // checkbox Role  
      checkBoxRole(data) {
        if (data.checkbox) {
          data.permissions.map((e) => {
            if (!this.listCheckBox.includes(e.permissionCode)) {
              console.log("data", this.listCheckBox.includes(e.permissionCode));
              this.listCheckBox.push(e.permissionCode)
            }
          })
        }
        if (!data.checkbox) {
          data.permissions.map((e) => {
            if (this.listCheckBox.includes(e.permissionCode)) {
              const index = this.listCheckBox.indexOf(e.permissionCode)
              if (index > -1) {
                this.listCheckBox.splice(index, 1)
              }
            }
          })
        }
      },
      isChecked(code) {
        return this.listCheckBox.includes(code)
      },
      // checkbox các permission thuộc Role 
      checkBoxPermisstion(data, item, index) {
        const exists = this.listCheckBox.includes(data.permissionCode)
        if (exists) {
          this.listCheckBox = this.listCheckBox.filter((c) => {
            return c !== data.permissionCode
          })
        } else {
          this.listCheckBox.push(data.permissionCode)
        }
        this.dataPermissions[index].checkbox = item.permissions.every((i) =>
          this.listCheckBox.includes(i.permissionCode)
        )
      },
    // tạo role mới
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.createRole();
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      }, 

      async createRole() {
          try {
            this.loading = true
            const params = {
              appId: process.env.VUE_APP_ID,
              roleName: this.ruleForm.roleName.trim(),
              description: this.ruleForm.description == '' || this.ruleForm.description == null 
                ? this.ruleForm.description : this.ruleForm.description.trim(),
              permissions: this.listCheckBox,
              createBy: this.inforAccount.username,
              merchantId: this.inforAccount.merchantId
            }
            const dataRes = await RoleService.createItemRole(params)
            if (dataRes.success) {
              Swal.fire({
                icon: 'success',
                title: '<a style="color:#3e69f6; font-size:20px; font-family:BeVietnam">Thành công</<a>',
                html:'<span style="color:#9093A4; font-size: 14px;" >Thêm mới thành công</span>',
                confirmButtonText: "Xác nhận",
              }).then((result) => {
                if (result.isConfirmed) {
                  this.$router.push({ path:`/employee-and-role`, hash: '#second'});
                }
              })
            } else if (dataRes.code == 'IAM_PERMISSION_NOT_FOUND') {
              Swal.fire({
                title: '<a style="color:#DC2323; font-size:20px; font-family:BeVietnam">Chưa chọn phân quyền</<a>',
                html: 'Bạn chưa chọn phân quyền nào cho vai trò này',
                imageUrl: require("@/assets/images/icon-modal-danger.svg"),
                imageWidth: 125,
                imageHeight: 125,
                cancelButtonText: 'Xác nhận',
                cancelButtonColor: '#DC2323',
                showCancelButton: true,
                showConfirmButton: false
              })
            } else if (dataRes.code == 'DUPLICATE_DATA') {
              Swal.fire({
                title: `<a style="color:#F6AB2F; font-size:20px; font-family:BeVietnam">Vai trò đã có trong hệ thống</<a>`,
                html: `Vui lòng chỉnh sửa tên vai trò để tiếp tục`, 
                imageUrl: require("@/assets/images/icon-modal-warning.svg"),
                imageWidth: 125,
                imageHeight: 125,
                showCancelButton: true,
                cancelButtonText: 'Đóng',
                showConfirmButton: false
              })
            } else {
              const txtHTML = dataRes.code == 'NOT_ALLOW_UPDATE_DEFAULT_ROLE_OWNER' ? 'Không cập nhật vai trò mặc định của chủ doanh nghiệp' : 'Không xóa vai trò của chủ doanh nghiệp'
              Swal.fire({
                title: `<a style="color:#F6AB2F; font-size:20px; font-family:BeVietnam">Vai trò của chủ doanh nghiệp</<a>`,
                html: txtHTML, 
                imageUrl: require("@/assets/images/icon-modal-warning.svg"),
                imageWidth: 125,
                imageHeight: 125,
                showCancelButton: false,
                showConfirmButton: false
              })
            }
          } catch (error) {
            console.log(error);
          } finally {
            this.loading = false
          }
      }
    }
  }
</script>
<style scoped>
    .groupPers {
        border-bottom: 1px solid #E5E7E8;
        padding-bottom: 15px;
        margin-bottom: 12px;
        width: 100%;
    }

    .group-head .group-item {
        font-size: 16px;
        font-weight: bold;
    }

    .line-item {
        margin-top: 12px;
        display: inline-block;
        width: 95%;
        margin-left: 15px;
    }

    .item-one {
        font-size: 15px;
        font-weight: 400;
        margin: 2px 0;
        display: inline-block;
        width: 100%;
        height: 38px;
    }

    .groupPers:last-child {
        border-bottom: none;
        margin-bottom: 0;
        padding-bottom: 0;
    }

    .item-check {
        display: inline-block;
        /* float: left; */
        vertical-align: top;
    }

    .item-name {
        display: inline-block;
        /* float: left; */
        width: 75%;
        vertical-align: top;
        margin-left: 8px;
        position: relative;
        top: -3px;
        font-size: 14px;
    }

    .fa-angle-double-down {
        color: #3E69F6;
        margin-left: 5px;
        top: 1px;
        position: relative;
    }

    .btn-default-ext {
        color: #222 !important;
        background: #F1F2F4 !important;
        border: 1px solid #F1F2F4 !important;
    }

    .box-img-modal {
        text-align: center;
    }

    .box-img-modal img {
        width: 55%;
    }

    .color_wrn {
        color: #F6AB2F !important;
    }
</style>

<style lang="scss" scoped>

.boxContent .__card {
  max-width: 960px;
  padding: 24px
}
.layout-wrapper {
  position: relative;

  #page-topbar {
    display: flex;
    justify-content: space-between;
    padding: 16px 24px;

    .title{
      position: absolute;
      font-weight: 600;
      font-size: 24px;
      color: #23313e;
      cursor: pointer;
      left: 50%;
      -webkit-transform: translateX(-50%);
      transform: translateX(-50%);
      align-self: center;
      
      p {
        margin: 0;
      }
    }
    
    .content {
      margin-top: 5.5em;
      padding: 20px 16.6% 120px 16.6%;
      min-height: 80vh;
    }
  }
}
</style>

<style lang="scss">
.boxContent {
  margin: 12px 0;
}

.el-form-item {
  width: 100%;
  margin-bottom: 0;
}

.el-form-item__label {
  color: #9093A4;
}

.el-form-item__content {
  width: 70%;
}
</style>>

